import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { ResponsiveDataList } from '../../Table/ResponsiveDataList.js';
import { getPagingInfo } from '../../Pagination.js';
import { PagedView } from '../page/component.js';
var _excluded = ["activePage", "createButtonDataProps", "tableContainerDataProps", "fields", "keyField", "loadAction", "onPageChange", "onSortChange", "options"];

var ListView = function ListView(_ref) {
  var _ref$activePage = _ref.activePage,
      activePage = _ref$activePage === void 0 ? 1 : _ref$activePage,
      createButtonDataProps = _ref.createButtonDataProps,
      tableContainerDataProps = _ref.tableContainerDataProps,
      fields = _ref.fields,
      _ref$keyField = _ref.keyField,
      keyField = _ref$keyField === void 0 ? 'id' : _ref$keyField,
      loadAction = _ref.loadAction,
      _ref$onPageChange = _ref.onPageChange,
      onPageChange = _ref$onPageChange === void 0 ? function () {} : _ref$onPageChange,
      _ref$onSortChange = _ref.onSortChange,
      onSortChange = _ref$onSortChange === void 0 ? function () {} : _ref$onSortChange,
      options = _ref.options,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      sort = _useState2[0],
      setSort = _useState2[1];

  var loadData = function loadData() {
    if (loadAction) {
      loadAction(sort, activePage);
    }
  };

  var onPageChangeHandler = function onPageChangeHandler(newActivePage) {
    onPageChange(newActivePage);
    setSort(null);
  };

  var onSortChangeHandler = function onSortChangeHandler(sortName, sortOrder) {
    onSortChange(sortName, sortOrder);
    onPageChangeHandler(1);
    setSort({
      value: sortName,
      direction: sortOrder
    });
  };

  useEffect(function () {
    if (activePage !== 1) {
      onPageChangeHandler(activePage);
    }
  }, [activePage]);

  var tableOptions = _objectSpread2({
    bordered: false,
    hover: true,
    striped: false,
    onSortChange: onSortChangeHandler
  }, options);

  var pagingInfo = getPagingInfo(rest);

  if (sort) {
    tableOptions.sortName = sort.value;
    tableOptions.sortOrder = sort.direction;
  }

  return /*#__PURE__*/React.createElement(PagedView, _extends({}, rest, {
    contentType: "list",
    activePage: activePage,
    createButtonDataProps: createButtonDataProps,
    onPageChange: onPageChangeHandler,
    loadData: loadData,
    useCoreTable: true
  }), /*#__PURE__*/React.createElement(ResponsiveDataList, _extends({}, rest, {
    keyField: keyField,
    fields: fields,
    tableContainerDataProps: tableContainerDataProps,
    options: tableOptions,
    onPageChange: onPageChange,
    pagingInfo: pagingInfo
  })));
};

ListView.displayName = "ListView";
export { ListView };